/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDiscrepanciesResponse } from '../../models/get-discrepancies-response';
import { KeyType } from '../../models/key-type';

export interface GetDiscrepanciesForDeliveryNoteCarrier$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
}

export function getDiscrepanciesForDeliveryNoteCarrier(http: HttpClient, rootUrl: string, params: GetDiscrepanciesForDeliveryNoteCarrier$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDiscrepanciesResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscrepanciesForDeliveryNoteCarrier.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDiscrepanciesResponse>;
    })
  );
}

getDiscrepanciesForDeliveryNoteCarrier.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/discrepancies';
